export const USER_DETAILS_VERSION = 4

export const MAX_FETCH_SETTINGS_TRIALS = 3
